// extracted by mini-css-extract-plugin
export default {"wrapperText":"ParallaxAbout2_wrapperText__CRDJp","title":"ParallaxAbout2_title__r2+WN","text":"ParallaxAbout2_text__LZtM-"};